import CryptoJS from 'crypto-js';

export const encryption = {
  generateHash: (value: string): string => {
    return CryptoJS.AES.encrypt(value, `${process.env.REACT_APP_CIPHER_KEY}`).toString();
  },
  decryptFromHash: (encrypted: string): string => {
    return CryptoJS.AES.decrypt(encrypted, `${process.env.REACT_APP_CIPHER_KEY}`).toString(CryptoJS.enc.Utf8);
  },
};